export const TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION';
export const TOGGLE_VIEW_MODE = 'TOGGLE_VIEW_MODE';
export const SET_CIC_DISPLAY_LANGUAGE = 'SET_CIC_DISPLAY_LANGUAGE';


export const SHOW_NAVIGATION_BAR = 'showNavigationBar';
export const VIEW_MODE = 'viewMode';
export const CIC_DISPLAY_LANGUAGE = 'cicDisplayLanguage';

export function getShowNavigationBar(state) {
  return state.get('rootReducer').get('uiState').get(SHOW_NAVIGATION_BAR);
}

export function getViewMode(state) {
  return state.get('rootReducer').get('uiState').get(VIEW_MODE);
}

export function getCICDisplayLanguage(state) {
  return state.get('rootReducer').get('uiState').get(CIC_DISPLAY_LANGUAGE);
}

export function toggleNavigation() {
  return {
    type: TOGGLE_NAVIGATION,
  };
}

export function toggleViewMode(viewMode) {
  return {
    type: TOGGLE_VIEW_MODE,
    viewMode,
  };
}

export function setCICDisplayLanguage(languageCode) {
  return {
    type: SET_CIC_DISPLAY_LANGUAGE,
    languageCode,
  };
}



// WEBPACK FOOTER //
// ./data/UiState/actions.js